import { render, staticRenderFns } from "./MotivationalSpeech.vue?vue&type=template&id=54c55744&scoped=true&lang=pug"
import script from "./MotivationalSpeech.vue?vue&type=script&lang=js"
export * from "./MotivationalSpeech.vue?vue&type=script&lang=js"
import style0 from "./MotivationalSpeech.vue?vue&type=style&index=0&id=54c55744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c55744",
  null
  
)

export default component.exports